import {
  createEntityAdapter,
  createSlice,
  EntityState,
} from "@reduxjs/toolkit";

import { fetchCaseInfo } from "../../../thunks/Case";
import { Account } from "../../../api/accounts";
import { RootState } from "../../../app/store";
import { addAccounts, updateAccount } from "./thunks";

export interface AccountsState {
  accounts: EntityState<Account, string>;
}

export const accountsAdapter = createEntityAdapter<Account, string>({
  selectId: (account) => account.account_number,
});

const initialState: AccountsState = {
  accounts: accountsAdapter.getInitialState(),
};

const accountsSlice = createSlice({
  name: "accounts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCaseInfo.pending, (state) => {
        accountsAdapter.removeAll(state.accounts);
      })
      .addCase(fetchCaseInfo.fulfilled, (state, action) => {
        const caseData = action.payload.cases?.[0];
        if (caseData?.accounts) {
          accountsAdapter.setAll(state.accounts, caseData.accounts);
        }
      })
      .addCase(addAccounts.fulfilled, (state, action) => {
        accountsAdapter.addMany(state.accounts, action.payload.accounts);
      })
      .addCase(updateAccount.fulfilled, (state, action) => {
        accountsAdapter.updateOne(state.accounts, {
          id: action.meta.arg.account_number,
          changes: action.meta.arg.request,
        });
      });
  },
});

export const accountsReducer = accountsSlice.reducer;

const accountsSelectors = accountsAdapter.getSelectors<RootState>(
  (state) => state.accounts.accounts,
);

export const {
  selectAll: getCaseAccounts,
  selectById: getCaseAccountByAccountNumber,
  selectEntities: getCaseAccountEntities,
} = accountsSelectors;
